import { render, staticRenderFns } from "./BookingsPage.vue?vue&type=template&id=a1a2aa8c&scoped=true&"
import script from "./BookingsPage.vue?vue&type=script&lang=js&"
export * from "./BookingsPage.vue?vue&type=script&lang=js&"
import style0 from "./BookingsPage.vue?vue&type=style&index=0&id=a1a2aa8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a2aa8c",
  null
  
)

export default component.exports